import { Text, VStack } from "native-base";
import React from "react";

import MobileHeader from "@/components/molecules/MobileHeader";
import SacButton from "@/components/molecules/SacButton";
import Container from "@/components/organisms/Container";

import HelpContainer from "./components/HelpContainer";
import { HelpCenterScreenProps } from "./types";

const HelpCentralMobile = ({ onBack }: HelpCenterScreenProps) => {
  return (
    <>
      <Container px="2" Header={<MobileHeader title="Central de Ajuda" onBackPress={onBack} />}>
        <VStack mb="32">
          <Text py="4" fontSize="lg" color="primary.600" bold>
            Como podemos te ajudar?
          </Text>
          <HelpContainer />
        </VStack>
      </Container>
      <SacButton />
    </>
  );
};

export default HelpCentralMobile;
